// extracted by mini-css-extract-plugin
module.exports = {"Appbar":"Appbar_Appbar__3STqI"};